import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import React from "react";
import { MdOutlineLightMode, MdOutlineNightlight } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { switchTheme } from "store/reducers/theme";

function SwitchTheme() {
  const { mode } = useSelector((state) => state.theme);
  const dispatch = useDispatch();
  const changeTheme = () => dispatch(switchTheme());

  return (
    <ToggleButtonGroup value={mode} onChange={changeTheme}>
      <ToggleButton value="light">
        <MdOutlineLightMode />
      </ToggleButton>
      <ToggleButton value="dark">
        <MdOutlineNightlight />
      </ToggleButton>
    </ToggleButtonGroup>
  );
}

export default SwitchTheme;
